var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashContained(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.084 5.66667V2.83333C22.084 2.08189 21.7855 1.36122 21.2541 0.829864C20.7228 0.298511 20.0021 0 19.2507 0L10.7507 0C9.9992 0 9.27853 0.298511 8.74718 0.829864C8.21583 1.36122 7.91732 2.08189 7.91732 2.83333V5.66667H0.833984V8.5H3.66732V29.75C3.66732 30.8772 4.11508 31.9582 4.91211 32.7552C5.70914 33.5522 6.79015 34 7.91732 34H22.084C23.2112 34 24.2922 33.5522 25.0892 32.7552C25.8862 31.9582 26.334 30.8772 26.334 29.75V8.5H29.1673V5.66667H22.084ZM13.584 24.0833H10.7507V15.5833H13.584V24.0833ZM19.2507 24.0833H16.4173V15.5833H19.2507V24.0833ZM19.2507 5.66667H10.7507V2.83333H19.2507V5.66667Z",
    fill: "#FF4E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashContained);
export default __webpack_public_path__ + "static/media/trash-contained.0e667dd8d133f031ec1224b28e324652.svg";
export { ForwardRef as ReactComponent };